import React from 'react';
import {
  Box, Typography, Chip, Divider, Avatar, Link
} from '@mui/material';
import PaymentsIcon from '@mui/icons-material/Payments';
import { brand } from '../../theme/colors';

const fmt = (n) => parseFloat(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function BOQLaborPaymentHistory({ payments = [] }) {
  if (payments.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 3, color: 'text.secondary' }}>
        <PaymentsIcon sx={{ fontSize: 32, mb: 1, opacity: 0.4 }} />
        <Typography variant="body2">No labour payments logged yet</Typography>
      </Box>
    );
  }

  return (
    <Box>
      {payments.map((payment, idx) => {
        const payer = payment.payer_profile || {};
        const payee = payment.payee_profile || {};

        return (
          <Box key={payment.id}>
            {idx > 0 && <Divider sx={{ my: 1.5 }} />}
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
              <Avatar sx={{ width: 32, height: 32, bgcolor: brand.primary, fontSize: '0.75rem' }}>
                {(payer.first_name || '?')[0]}
              </Avatar>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {payer.first_name || 'Project owner'} {payer.last_name || ''}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    paid {payee.first_name || 'contractor'} {payee.last_name || ''}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {new Date(payment.payment_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5, flexWrap: 'wrap' }}>
                  <Chip
                    label={`$${fmt(payment.amount)}`}
                    size="small"
                    sx={{ fontFamily: 'monospace', fontWeight: 700, bgcolor: brand.primary + '12', color: brand.primaryDark }}
                  />
                  <Chip
                    label={payment.status}
                    size="small"
                    variant="outlined"
                    sx={{ textTransform: 'capitalize', fontSize: '0.7rem' }}
                  />
                </Box>
                {payment.proof_url && (
                  <Typography variant="caption" sx={{ display: 'block', mt: 0.5 }}>
                    <Link href={payment.proof_url} target="_blank" rel="noreferrer">View proof</Link>
                  </Typography>
                )}
                {payment.notes && (
                  <Typography variant="caption" sx={{ display: 'block', mt: 0.5, fontStyle: 'italic', color: 'text.secondary' }}>
                    {payment.notes}
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
